import type { PropsWithChildren } from 'react';

import { cn } from '@/utils/cn';

export const MessageFrame = ({
	children,
	className,
}: PropsWithChildren<{ className?: string }>) => {
	return (
		<div
			className={cn('glass-card-sm flex w-full flex-col gap-8 p-4', className)}
		>
			{children}
		</div>
	);
};
